/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Accept_Waiver_ToastInputs */

const en_booking_accept_waiver_toast = /** @type {(inputs: Booking_Accept_Waiver_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please accept the waiver to continue`)
};

const es_booking_accept_waiver_toast = /** @type {(inputs: Booking_Accept_Waiver_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor acepta la exención para continuar`)
};

const fr_booking_accept_waiver_toast = /** @type {(inputs: Booking_Accept_Waiver_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez accepter la décharge pour continuer`)
};

const de_booking_accept_waiver_toast = /** @type {(inputs: Booking_Accept_Waiver_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte akzeptiere die Verzichtserklärung, um fortzufahren`)
};

const id_booking_accept_waiver_toast = /** @type {(inputs: Booking_Accept_Waiver_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silakan setujui pembebasan tanggung jawab untuk melanjutkan`)
};

/** @type {(inputs: Booking_Accept_Waiver_ToastInputs) => LocalizedString} */
const ja_booking_accept_waiver_toast = en_booking_accept_waiver_toast;

/** @type {(inputs: Booking_Accept_Waiver_ToastInputs) => LocalizedString} */
const zh_booking_accept_waiver_toast = en_booking_accept_waiver_toast;

/** @type {(inputs: Booking_Accept_Waiver_ToastInputs) => LocalizedString} */
const ar_booking_accept_waiver_toast = en_booking_accept_waiver_toast;

/** @type {(inputs: Booking_Accept_Waiver_ToastInputs) => LocalizedString} */
const it_booking_accept_waiver_toast = en_booking_accept_waiver_toast;

/** @type {(inputs: Booking_Accept_Waiver_ToastInputs) => LocalizedString} */
const ru_booking_accept_waiver_toast = en_booking_accept_waiver_toast;

/** @type {(inputs: Booking_Accept_Waiver_ToastInputs) => LocalizedString} */
const pt_booking_accept_waiver_toast = en_booking_accept_waiver_toast;

/** @type {(inputs: Booking_Accept_Waiver_ToastInputs) => LocalizedString} */
const ko_booking_accept_waiver_toast = en_booking_accept_waiver_toast;

/**
* | output |
* | --- |
* | "Please accept the waiver to continue" |
*
* @param {Booking_Accept_Waiver_ToastInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_accept_waiver_toast = /** @type {((inputs?: Booking_Accept_Waiver_ToastInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Accept_Waiver_ToastInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_accept_waiver_toast(inputs)
	if (locale === "es") return es_booking_accept_waiver_toast(inputs)
	if (locale === "fr") return fr_booking_accept_waiver_toast(inputs)
	if (locale === "de") return de_booking_accept_waiver_toast(inputs)
	if (locale === "ja") return ja_booking_accept_waiver_toast(inputs)
	if (locale === "zh") return zh_booking_accept_waiver_toast(inputs)
	if (locale === "ar") return ar_booking_accept_waiver_toast(inputs)
	if (locale === "id") return id_booking_accept_waiver_toast(inputs)
	if (locale === "it") return it_booking_accept_waiver_toast(inputs)
	if (locale === "ru") return ru_booking_accept_waiver_toast(inputs)
	if (locale === "pt") return pt_booking_accept_waiver_toast(inputs)
	return ko_booking_accept_waiver_toast(inputs)
});